import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import { apolloClient } from '@/apollo/apolloClient';
import { GET_MEMBER, SEARCH_MEMBERS_WITH_AFFILIATION, INDUSTRY_MAJOR_LIST, INDUSTRY_MIDDLE_LIST, INDUSTRY_MIDDLE_INFO, GET_ROLES, GET_ROLE_BY_ID, GET_USER_COUNT_BY_ROLE_ID, AFFILIATION_LIST, GET_PLAN_USER, GET_ROLE_DEFAULT as _GET_ROLE_DEFAULT } from '@/apollo/queries/company-query';
import { INSERT_ROLE, UPDATE_ROLE, DELETE_ROLES, INSERT_USER_ROLE_CHAT_POLICY, DEACTIVATE_USER_ROLE_CHAT_POLICY, DELETE_EMPLOYEES_BY_DELETED_AT } from '@/apollo/mutations/company-mutation';
import { getZoneId } from "../../utils/auth";
import { formatUserAffiliations } from '@/utils/validate';
var state = {
  // ページング（ページトップNo）
  page_top: 0,
  // ページング（１ページあたりの表示サイズ）
  page_size: 30,
  // ページング（全一覧数）
  page_count: 0,
  // ページング（最終ページ）
  page_last: 0,
  // 文字検索
  searching: '',
  // 企業名検索
  searchCompanyName: '',
  // 代表者名
  searchCtoName: '',
  // 業種名／職種名検索
  searchIndustryName: '',
  // 電話番号検索
  searchTel: '',
  industrys: [],
  branchs: [],
  display: [],
  login: [],
  occupations: [],
  certificationMarks: [],
  area: [],
  companies: [],
  company_id: null,
  uid: '',
  area_id: '',
  branchCode: null,
  areaCode: null,
  majorCode: null,
  middleCode: null,
  industry_major: null,
  industry_middle: null,
  industry_code: '',
  industry_info: [],
  group_id: '',
  company: [],
  members: [],
  member: [],
  affiliationList: [],
  pathToListItem: [],
  enableTextAllSelect: false,
  listAllIdsFromLastItem: [],
  userRoles: [],
  userRoleByIdList: [],
  roleSearch: null,
  setOptionValue: null,
  // / 1 Roles一覧-ドロップダウン, 2 ドロップダウン
  is_active: null,
  search_user_count: 0,
  roleDefault: {},
  // 社員名簿一覧で最後に検索した条件。詳細画面から戻ったときなど、一覧を開き直したときの復元に使う
  memberListCondition: null,
  // ログアウトのたびに進む番号。検索の開始時と結果の受信時で値が違えば、その検索の条件は保存しない
  memberListConditionGeneration: 0
};
var mutations = {
  UPDATE_COMPANY: function UPDATE_COMPANY(state, user) {
    state.member = user;
  },
  UPDATE_COMPANY_LIST: function UPDATE_COMPANY_LIST(state, company) {
    state.companies = company.map(function (com) {
      com.thumbsUp = com.like.aggregate.count;
      com.viewed = com.browse.aggregate.count;

      if (com.profile === null) {
        com.industry = '';
        com.cto = '';
        com.address = '';
        com.tel = '';
        com.email = '';
      } else {
        if (com.industry_companies.length === 0) {
          com.industry = '';
        } else {
          com.industry = com.industry_companies[0].industry.name;
        }

        com.cto = com.profile.cto;
        com.address = com.profile.address;
        com.tel = com.profile.tel;
        com.email = com.profile.email;
      }

      return com;
    });
  },
  UPDATE_MEMBERS: function UPDATE_MEMBERS(state, user) {
    state.members = user.map(function (com) {
      com.name = com.last_name + ' ' + com.frist_name;
      com.name_kana = com.last_name_kana + ' ' + com.frist_name_kana;
      com.hasRoleChatCount = com.user_role_chat_count.aggregate.count !== 0;

      if (com.company !== null) {
        com.company_name = com.company.company_name;

        if (com.company.industries != null) {
          com.industry_name = com.company.industries.industry_name;
        } else {
          com.industry_name = '';
        }
      } else {
        com.company_name = '';
        com.industry_name = '';
      }

      com.userAffiliation = formatUserAffiliations(com.user_affiliations);

      if (com.is_active) {
        com.is_active = 'ログイン可';
      } else {
        com.is_active = 'ログイン不可';
      }

      return com;
    });
  },
  CREATE_INDUSTRY_MAJOR_LIST: function CREATE_INDUSTRY_MAJOR_LIST(state, industry_major) {
    state.industry_major = industry_major.map(function (com) {
      com.no = com.id;
      com.title = com.name;
      return com;
    });
  },
  CREATE_INDUSTRY_MIDDLE_LIST: function CREATE_INDUSTRY_MIDDLE_LIST(state, industry_middle) {
    state.industry_middle = industry_middle.map(function (com) {
      com.no = com.code;
      com.title = com.name;
      return com;
    });
  },
  CREATE_INDUSTRY_MIDDLE_INFO: function CREATE_INDUSTRY_MIDDLE_INFO(state, industry_middle) {
    state.industry_info = industry_middle;
  },
  CREATE_DISPLAY_LIST: function CREATE_DISPLAY_LIST(state, display) {
    state.display = display.map(function (com) {
      com.no = com.id;
      com.title = com.name;
      return com;
    });
  },
  CREATE_LOGIN_LIST: function CREATE_LOGIN_LIST(state, login) {
    state.login = login.map(function (com) {
      com.no = com.id;
      com.title = com.name;
      return com;
    });
  },
  GET_ALL_AFFILIATION: function GET_ALL_AFFILIATION(state, _affilication) {
    // /tree listのすべての配列に 全てのグループ を追加します
    var counter = -1;

    function getMapAffilication(_subAffiliation) {
      if (_subAffiliation.affiliations.length > 1) {
        counter = counter - 1;

        if (_subAffiliation.affiliations[0].name !== '全てのグループ' && state.enableTextAllSelect) {
          _subAffiliation.affiliations.unshift({
            affiliations: [],
            id: counter,
            name: '全てのグループ',
            parent_id: _subAffiliation.affiliations[0].parent_id
          });
        }
      }

      return _subAffiliation.affiliations.map(function (subItem) {
        return getMapAffilication(subItem);
      });
    }

    if (_affilication[0].name !== '全てのグループ' && state.enableTextAllSelect) {
      _affilication.unshift({
        affiliations: [],
        id: counter,
        name: '全てのグループ',
        parent_id: _affilication[0].parent_id
      });
    }

    _affilication.map(function (itemAffilication) {
      return getMapAffilication(itemAffilication);
    });

    state.affiliationList = _affilication;
  },
  CREATE_ROLE_LIST: function CREATE_ROLE_LIST(state, userRoleInput) {
    if (!userRoleInput || !userRoleInput.length) {
      return;
    }

    if (state.setOptionValue === 1) {
      userRoleInput.unshift({
        id: null,
        name: '全ての役割'
      });
    }

    state.userRoles = _toConsumableArray(new Set(userRoleInput));
  },
  CREATE_ROLE_BY_ID_LIST: function CREATE_ROLE_BY_ID_LIST(state, role) {
    state.userRoleByIdList = role;
  },
  setPageTop: function setPageTop(state, val) {
    state.page_top = val;
  },
  setPageSize: function setPageSize(state, val) {
    state.page_size = val;
  },
  setPageCount: function setPageCount(state, val) {
    state.page_count = val;
  },
  setSearching: function setSearching(state, val) {
    state.searching = val;
  },
  setCtoName: function setCtoName(state, val) {
    state.searchCtoName = val;
  },
  setCompanyName: function setCompanyName(state, val) {
    state.searchCompanyName = val;
  },
  setIndustryName: function setIndustryName(state, val) {
    state.searchIndustryName = val;
  },
  setTel: function setTel(state, val) {
    state.searchTel = val;
  },
  setMajorCode: function setMajorCode(state, val) {
    state.majorCode = val;
  },
  setMiddleCode: function setMiddleCode(state, val) {
    state.middleCode = val;
  },
  clear: function clear(state) {
    state.searching = '';
    state.branchCode = null;
    state.areaCode = null;
    state.majorCode = null;
    state.middleCode = null;
    state.searchCtoName = '';
    state.searchCompanyName = '';
    state.searchIndustryName = '';
    state.searchTel = '';
    state.industrys = [];
    state.industry_major = []; // 大分類

    state.industry_middle = []; // 中分類

    state.branchs = [];
    state.area = [];
    state.industry_info = [];
    state.industry_code = '';
    state.display = [];
    state.login = [];
    state.occupations = [];
    state.certificationMarks = [];
    state.companies = [];
    state.company = [];
    state.company_id = null;
  },
  pathToListItem: function pathToListItem(state, val) {
    state.pathToListItem = val;
  },
  setEnableTextAllSelect: function setEnableTextAllSelect(state, val) {
    state.enableTextAllSelect = val;
  },
  getDataSearchAffiliation: function getDataSearchAffiliation(state, val) {
    state.listAllIdsFromLastItem = val;
  },
  setOptionValue: function setOptionValue(state, val) {
    state.setOptionValue = val;
  },
  setRoleSearch: function setRoleSearch(state, val) {
    state.roleSearch = val;
  },
  setIsActive: function setIsActive(state, val) {
    state.is_active = val;
  },
  SAVE_MEMBER_LIST_CONDITION: function SAVE_MEMBER_LIST_CONDITION(state, condition) {
    state.memberListCondition = condition;
  },
  CLEAR_MEMBER_LIST_CONDITION: function CLEAR_MEMBER_LIST_CONDITION(state) {
    state.memberListCondition = null;
    state.memberListConditionGeneration++;
  }
};
var actions = {
  getIndustryMajorList: function () {
    var _getIndustryMajorList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return apolloClient.query({
                query: INDUSTRY_MAJOR_LIST
              });

            case 3:
              res = _context.sent;
              commit('CREATE_INDUSTRY_MAJOR_LIST', res.data.industry_group);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getIndustryMajorList(_x) {
      return _getIndustryMajorList.apply(this, arguments);
    }

    return getIndustryMajorList;
  }(),
  getIndustryMiddleList: function () {
    var _getIndustryMiddleList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref2, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              this.state.group_id = data.group_id;
              _context2.next = 4;
              return apolloClient.query({
                query: INDUSTRY_MIDDLE_LIST,
                variables: {
                  group_id: this.state.group_id
                }
              });

            case 4:
              res = _context2.sent;
              commit('CREATE_INDUSTRY_MIDDLE_LIST', res.data.industries);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getIndustryMiddleList(_x2, _x3) {
      return _getIndustryMiddleList.apply(this, arguments);
    }

    return getIndustryMiddleList;
  }(),
  getIndustryMiddleInfo: function () {
    var _getIndustryMiddleInfo = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref3, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              this.state.industry_code = data.industry_code;
              _context3.next = 4;
              return apolloClient.query({
                query: INDUSTRY_MIDDLE_INFO,
                variables: {
                  code: this.state.industry_code
                }
              });

            case 4:
              res = _context3.sent;
              commit('CREATE_INDUSTRY_MIDDLE_INFO', res.data.industries);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getIndustryMiddleInfo(_x4, _x5) {
      return _getIndustryMiddleInfo.apply(this, arguments);
    }

    return getIndustryMiddleInfo;
  }(),
  getSearchIndustryMajorList: function () {
    var _getSearchIndustryMajorList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(_ref4) {
      var commit, res, add;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              _context4.next = 3;
              return apolloClient.query({
                query: INDUSTRY_MAJOR_LIST
              });

            case 3:
              res = _context4.sent;
              add = {
                id: 0,
                name: '全ての大分類'
              };

              if (res.data.industry_group[0].id !== 0) {
                res.data.industry_group.unshift(add);
              }

              commit('CREATE_INDUSTRY_MAJOR_LIST', res.data.industry_group);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function getSearchIndustryMajorList(_x6) {
      return _getSearchIndustryMajorList.apply(this, arguments);
    }

    return getSearchIndustryMajorList;
  }(),
  getSearchIndustryMiddleList: function () {
    var _getSearchIndustryMiddleList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(_ref5, data) {
      var commit, res, industry_middle_list, add, add2;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              this.state.group_id = data.group_id;
              _context5.next = 4;
              return apolloClient.query({
                query: INDUSTRY_MIDDLE_LIST,
                variables: {
                  group_id: this.state.group_id
                }
              });

            case 4:
              res = _context5.sent;
              industry_middle_list = [];

              if (res.data.industries[0] !== undefined) {
                add = {
                  code: '00',
                  name: '全ての中分類'
                };
                industry_middle_list = res.data.industries;
                industry_middle_list.unshift(add);
              } else {
                add2 = {
                  code: '00',
                  name: '全ての中分類'
                };
                industry_middle_list.unshift(add2);
              }

              commit('CREATE_INDUSTRY_MIDDLE_LIST', industry_middle_list);

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function getSearchIndustryMiddleList(_x7, _x8) {
      return _getSearchIndustryMiddleList.apply(this, arguments);
    }

    return getSearchIndustryMiddleList;
  }(),
  getDisplayList: function () {
    var _getDisplayList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(_ref6) {
      var commit, displayList;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit;
              displayList = [{
                id: false,
                name: '公開しない'
              }, {
                id: true,
                name: '公開する'
              }];
              commit('CREATE_DISPLAY_LIST', displayList);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function getDisplayList(_x9) {
      return _getDisplayList.apply(this, arguments);
    }

    return getDisplayList;
  }(),
  getLoginList: function () {
    var _getLoginList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(_ref7) {
      var commit, loginList;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref7.commit;

              if (state.setOptionValue === 1) {
                loginList = [{
                  id: null,
                  name: '全てのログイン権限'
                }, {
                  id: false,
                  name: 'ログイン不可'
                }, {
                  id: true,
                  name: 'ログイン可'
                }];
              } else {
                loginList = [{
                  id: false,
                  name: 'ログイン不可'
                }, {
                  id: true,
                  name: 'ログイン可'
                }];
              }

              commit('CREATE_LOGIN_LIST', loginList);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function getLoginList(_x10) {
      return _getLoginList.apply(this, arguments);
    }

    return getLoginList;
  }(),
  fetchCompany: function () {
    var _fetchCompany = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8(_ref8, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref8.commit;
              this.state.uid = data.uid;
              _context8.next = 4;
              return apolloClient.query({
                query: GET_MEMBER,
                variables: {
                  uid: this.state.uid
                }
              });

            case 4:
              res = _context8.sent;
              commit('UPDATE_COMPANY', res.data.user);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function fetchCompany(_x11, _x12) {
      return _fetchCompany.apply(this, arguments);
    }

    return fetchCompany;
  }(),
  // generation: 条件を保存してよいログインの番号（memberListConditionGeneration）。
  // 省略時は呼び出した時点の番号。一覧の表示処理のように、途中でログアウトをまたぎうる一連の処理の先頭で取った番号を渡す
  fetchMembers: function () {
    var _fetchMembers = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee11(_ref9) {
      var commit,
          _ref10,
          _ref10$generation,
          generation,
          condition,
          _sText,
          affiliations,
          result,
          doritos,
          getUserData,
          _getUserData,
          _args11 = arguments;

      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _getUserData = function _ref13() {
                _getUserData = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee10() {
                  var res, userResult;
                  return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _context10.next = 2;
                          return apolloClient.query({
                            query: SEARCH_MEMBERS_WITH_AFFILIATION,
                            variables: {
                              search_word: _sText,
                              affiliations: affiliations,
                              industry_code: state.middleCode,
                              group_industry_id: state.majorCode,
                              page_top: state.page_top * state.page_size,
                              roleId: state.roleSearch,
                              page_size: state.page_size,
                              is_active_only: state.is_active
                            }
                          });

                        case 2:
                          res = _context10.sent;

                          if (!res.data) {
                            _context10.next = 14;
                            break;
                          }

                          userResult = res.data;
                          result = userResult.search_user_admin_site;
                          state.page_count = userResult.search_user_admin_site_aggregate.aggregate.count;
                          state.search_user_count = userResult.search_user_admin_site_aggregate.aggregate.count;
                          state.page_last = userResult.search_user_admin_site_aggregate.aggregate.count === 0 ? 0 : Math.ceil(userResult.search_user_admin_site_aggregate.aggregate.count / state.page_size) - 1;
                          commit('UPDATE_MEMBERS', result); // 検索中にログアウト（トークン失効を含む）していたら、前のユーザーの条件なので保存しない

                          if (generation === state.memberListConditionGeneration) {
                            commit('SAVE_MEMBER_LIST_CONDITION', condition);
                          }

                          return _context10.abrupt("return");

                        case 14:
                          if (!(doritos <= 2500)) {
                            _context10.next = 19;
                            break;
                          }

                          doritos += 200;
                          return _context10.abrupt("return", setTimeout(
                          /*#__PURE__*/
                          _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee9() {
                            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                              while (1) {
                                switch (_context9.prev = _context9.next) {
                                  case 0:
                                    _context9.next = 2;
                                    return getUserData();

                                  case 2:
                                    return _context9.abrupt("return", _context9.sent);

                                  case 3:
                                  case "end":
                                    return _context9.stop();
                                }
                              }
                            }, _callee9);
                          })), doritos));

                        case 19:
                          return _context10.abrupt("return");

                        case 20:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                }));
                return _getUserData.apply(this, arguments);
              };

              getUserData = function _ref12() {
                return _getUserData.apply(this, arguments);
              };

              commit = _ref9.commit;
              _ref10 = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {}, _ref10$generation = _ref10.generation, generation = _ref10$generation === void 0 ? state.memberListConditionGeneration : _ref10$generation;
              // 検索に使う条件。結果を表示できたときだけ、一覧の復元用に保存する。
              // 組織は、一覧を開き直したときに最新の組織ツリーで選び直すため、選択した経路の組織IDだけを持つ
              condition = {
                searching: state.searching,
                roleSearch: state.roleSearch,
                affiliationPathIds: state.pathToListItem.map(function (item) {
                  return item.id;
                }),
                page_top: state.page_top
              };
              _sText = null;

              if (state.searching) {
                _sText = state.searching.trim();
              }

              affiliations = state.listAllIdsFromLastItem.length === 0 ? null : state.listAllIdsFromLastItem.join();
              result = []; // / データエラーが判明したら削除します

              doritos = 0;
              _context11.next = 12;
              return getUserData();

            case 12:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function fetchMembers(_x13) {
      return _fetchMembers.apply(this, arguments);
    }

    return fetchMembers;
  }(),
  fetchAffiliation: function () {
    var _fetchAffiliation = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee12(_ref14) {
      var commit, res, dataAffiliation, fakeIdAffiliation, indexFake;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              fakeIdAffiliation = function _ref15(affiliation) {
                affiliation.idFake = indexFake;
                indexFake++;
                if (affiliation.affiliations) return affiliation.affiliations.map(function (item) {
                  return fakeIdAffiliation(item);
                });
              };

              commit = _ref14.commit;
              _context12.next = 4;
              return apolloClient.query({
                query: AFFILIATION_LIST
              });

            case 4:
              res = _context12.sent;
              dataAffiliation = res.data.affiliation;

              if (dataAffiliation.length !== 0 && dataAffiliation) {
                indexFake = 0;
                dataAffiliation.map(function (item) {
                  return fakeIdAffiliation(item);
                });
              }

              commit('GET_ALL_AFFILIATION', dataAffiliation);

            case 8:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function fetchAffiliation(_x14) {
      return _fetchAffiliation.apply(this, arguments);
    }

    return fetchAffiliation;
  }(),
  getRoles: function () {
    var _getRoles = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee13(_ref16) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit = _ref16.commit;
              _context13.t0 = apolloClient;
              _context13.t1 = GET_ROLES;
              _context13.next = 5;
              return getZoneId();

            case 5:
              _context13.t2 = _context13.sent;
              _context13.t3 = {
                zone_id: _context13.t2
              };
              _context13.t4 = {
                query: _context13.t1,
                variables: _context13.t3
              };
              _context13.next = 10;
              return _context13.t0.query.call(_context13.t0, _context13.t4);

            case 10:
              res = _context13.sent;
              commit('CREATE_ROLE_LIST', res.data.roles);

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function getRoles(_x15) {
      return _getRoles.apply(this, arguments);
    }

    return getRoles;
  }(),
  getUserCountByRoleId: function () {
    var _getUserCountByRoleId = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee14(_ref17, roleId) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              commit = _ref17.commit;
              _context14.next = 3;
              return apolloClient.query({
                query: GET_USER_COUNT_BY_ROLE_ID,
                variables: {
                  role_id: roleId
                }
              });

            case 3:
              res = _context14.sent;

              if (!res.data) {
                _context14.next = 12;
                break;
              }

              if (!(res.data.user_count.aggregate.count === 0)) {
                _context14.next = 9;
                break;
              }

              return _context14.abrupt("return", true);

            case 9:
              return _context14.abrupt("return", false);

            case 10:
              _context14.next = 13;
              break;

            case 12:
              false;

            case 13:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function getUserCountByRoleId(_x16, _x17) {
      return _getUserCountByRoleId.apply(this, arguments);
    }

    return getUserCountByRoleId;
  }(),
  getRoleById: function () {
    var _getRoleById = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee15(_ref18, roleId) {
      var commit, resRole;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              commit = _ref18.commit;
              _context15.next = 3;
              return apolloClient.query({
                query: GET_ROLE_BY_ID,
                variables: {
                  id: roleId
                }
              });

            case 3:
              resRole = _context15.sent;
              commit('CREATE_ROLE_BY_ID_LIST', resRole.data.role);

            case 5:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function getRoleById(_x18, _x19) {
      return _getRoleById.apply(this, arguments);
    }

    return getRoleById;
  }(),
  insertRoles: function () {
    var _insertRoles = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee16(_ref19, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              commit = _ref19.commit;
              _context16.next = 3;
              return apolloClient.mutate({
                mutation: INSERT_ROLE,
                variables: {
                  roles: data.roles
                }
              });

            case 3:
              res = _context16.sent;

              if (!res.data) {
                _context16.next = 8;
                break;
              }

              return _context16.abrupt("return", true);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    function insertRoles(_x20, _x21) {
      return _insertRoles.apply(this, arguments);
    }

    return insertRoles;
  }(),
  updateRoles: function () {
    var _updateRoles = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee17(_ref20, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              commit = _ref20.commit;
              _context17.next = 3;
              return apolloClient.mutate({
                mutation: UPDATE_ROLE,
                variables: {
                  id: data.id,
                  roles: data.roles
                }
              });

            case 3:
              res = _context17.sent;

              if (!res.data) {
                _context17.next = 8;
                break;
              }

              return _context17.abrupt("return", true);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    function updateRoles(_x22, _x23) {
      return _updateRoles.apply(this, arguments);
    }

    return updateRoles;
  }(),
  deleteRoleById: function () {
    var _deleteRoleById = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee18(_ref21, roleId) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              commit = _ref21.commit;
              _context18.next = 3;
              return apolloClient.mutate({
                mutation: DELETE_ROLES,
                variables: {
                  id: roleId
                }
              });

            case 3:
              res = _context18.sent;

              if (!res.data) {
                _context18.next = 8;
                break;
              }

              return _context18.abrupt("return", true);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    function deleteRoleById(_x24, _x25) {
      return _deleteRoleById.apply(this, arguments);
    }

    return deleteRoleById;
  }(),
  getPlanUser: function () {
    var _getPlanUser = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee19(_ref22, roleId) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              commit = _ref22.commit;
              _context19.t0 = apolloClient;
              _context19.t1 = GET_PLAN_USER;
              _context19.next = 5;
              return getZoneId();

            case 5:
              _context19.t2 = _context19.sent;
              _context19.t3 = {
                zone_id: _context19.t2
              };
              _context19.t4 = {
                query: _context19.t1,
                variables: _context19.t3
              };
              _context19.next = 10;
              return _context19.t0.query.call(_context19.t0, _context19.t4);

            case 10:
              res = _context19.sent;

              if (!res.data) {
                _context19.next = 15;
                break;
              }

              return _context19.abrupt("return", {
                max_user: res.data.planUser.plan.max_user,
                name: res.data.planUser.plan.name,
                user_count: res.data.user_count.aggregate.count,
                warning_when_reach_max_user: res.data.planUser.warning_when_reach_max_user
              });

            case 15:
              throw res.errors[0].message;

            case 16:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    function getPlanUser(_x26, _x27) {
      return _getPlanUser.apply(this, arguments);
    }

    return getPlanUser;
  }(),
  INSERT_USER_ROLE_CHAT_POLICY_MUTATE: function () {
    var _INSERT_USER_ROLE_CHAT_POLICY_MUTATE = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee20(_ref23, role_chat_policy) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              commit = _ref23.commit;
              _context20.next = 3;
              return apolloClient.mutate({
                mutation: INSERT_USER_ROLE_CHAT_POLICY,
                variables: {
                  objects: role_chat_policy
                }
              });

            case 3:
              res = _context20.sent;

              if (!res.data) {
                _context20.next = 8;
                break;
              }

              return _context20.abrupt("return", true);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    function INSERT_USER_ROLE_CHAT_POLICY_MUTATE(_x28, _x29) {
      return _INSERT_USER_ROLE_CHAT_POLICY_MUTATE.apply(this, arguments);
    }

    return INSERT_USER_ROLE_CHAT_POLICY_MUTATE;
  }(),
  DEACTIVATE_USER_ROLE_CHAT_POLICY_MUTATE: function () {
    var _DEACTIVATE_USER_ROLE_CHAT_POLICY_MUTATE = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee21(_ref24, uid) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              commit = _ref24.commit;
              _context21.next = 3;
              return apolloClient.mutate({
                mutation: DEACTIVATE_USER_ROLE_CHAT_POLICY,
                variables: {
                  uid: uid
                }
              });

            case 3:
              res = _context21.sent;

              if (!res.data) {
                _context21.next = 8;
                break;
              }

              return _context21.abrupt("return", true);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    function DEACTIVATE_USER_ROLE_CHAT_POLICY_MUTATE(_x30, _x31) {
      return _DEACTIVATE_USER_ROLE_CHAT_POLICY_MUTATE.apply(this, arguments);
    }

    return DEACTIVATE_USER_ROLE_CHAT_POLICY_MUTATE;
  }(),
  GET_ROLE_DEFAULT: function () {
    var _GET_ROLE_DEFAULT2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee22(_ref25) {
      var commit, getRole;
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              commit = _ref25.commit;
              _context22.next = 3;
              return apolloClient.query({
                query: _GET_ROLE_DEFAULT
              });

            case 3:
              getRole = _context22.sent;

              if (!getRole.data) {
                _context22.next = 8;
                break;
              }

              state.roleDefault = getRole.data.role;
              _context22.next = 9;
              break;

            case 8:
              throw getRole.errors[0].message;

            case 9:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    function GET_ROLE_DEFAULT(_x32) {
      return _GET_ROLE_DEFAULT2.apply(this, arguments);
    }

    return GET_ROLE_DEFAULT;
  }(),
  DELETE_EMPLOYEES_BY_DELETED_AT_MUTATION: function () {
    var _DELETE_EMPLOYEES_BY_DELETED_AT_MUTATION = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee23(_ref26, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              commit = _ref26.commit;
              _context23.next = 3;
              return apolloClient.mutate({
                mutation: DELETE_EMPLOYEES_BY_DELETED_AT,
                variables: {
                  uid: data
                }
              });

            case 3:
              res = _context23.sent;

              if (!res.data) {
                _context23.next = 8;
                break;
              }

              return _context23.abrupt("return", true);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    function DELETE_EMPLOYEES_BY_DELETED_AT_MUTATION(_x33, _x34) {
      return _DELETE_EMPLOYEES_BY_DELETED_AT_MUTATION.apply(this, arguments);
    }

    return DELETE_EMPLOYEES_BY_DELETED_AT_MUTATION;
  }(),
  setSearching: function () {
    var _setSearching = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee24(_ref27, searching) {
      var commit;
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              commit = _ref27.commit;
              commit('setSearching', searching);

            case 2:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    function setSearching(_x35, _x36) {
      return _setSearching.apply(this, arguments);
    }

    return setSearching;
  }(),
  setMajorCode: function () {
    var _setMajorCode = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee25(_ref28, majorCode) {
      var commit;
      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              commit = _ref28.commit;
              commit('setMajorCode', majorCode);

            case 2:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    function setMajorCode(_x37, _x38) {
      return _setMajorCode.apply(this, arguments);
    }

    return setMajorCode;
  }(),
  setMiddleCode: function () {
    var _setMiddleCode = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee26(_ref29, middleCode) {
      var commit;
      return regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              commit = _ref29.commit;
              commit('setMiddleCode', middleCode);

            case 2:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    function setMiddleCode(_x39, _x40) {
      return _setMiddleCode.apply(this, arguments);
    }

    return setMiddleCode;
  }(),
  setPageTop: function () {
    var _setPageTop = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee27(_ref30, page_top) {
      var commit;
      return regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              commit = _ref30.commit;
              commit('setPageTop', page_top);

            case 2:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    function setPageTop(_x41, _x42) {
      return _setPageTop.apply(this, arguments);
    }

    return setPageTop;
  }(),
  getPageTop: function () {
    var _getPageTop = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee28(_ref31) {
      var commit;
      return regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              commit = _ref31.commit;
              return _context28.abrupt("return", state.page_top);

            case 2:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    function getPageTop(_x43) {
      return _getPageTop.apply(this, arguments);
    }

    return getPageTop;
  }(),
  getPageLast: function () {
    var _getPageLast = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee29(_ref32) {
      var commit;
      return regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              commit = _ref32.commit;
              return _context29.abrupt("return", state.page_last);

            case 2:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    function getPageLast(_x44) {
      return _getPageLast.apply(this, arguments);
    }

    return getPageLast;
  }(),
  setPageSize: function () {
    var _setPageSize = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee30(_ref33, page_size) {
      var commit;
      return regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              commit = _ref33.commit;
              commit('setPageSize', page_size);

            case 2:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    function setPageSize(_x45, _x46) {
      return _setPageSize.apply(this, arguments);
    }

    return setPageSize;
  }(),
  setPageCount: function () {
    var _setPageCount = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee31(_ref34, page_count) {
      var commit;
      return regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              commit = _ref34.commit;
              commit('setPageCount', page_count);

            case 2:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    function setPageCount(_x47, _x48) {
      return _setPageCount.apply(this, arguments);
    }

    return setPageCount;
  }(),
  getPageCount: function () {
    var _getPageCount = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee32(_ref35) {
      var commit;
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              commit = _ref35.commit;
              return _context32.abrupt("return", state.page_count);

            case 2:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32);
    }));

    function getPageCount(_x49) {
      return _getPageCount.apply(this, arguments);
    }

    return getPageCount;
  }(),
  setCtoName: function () {
    var _setCtoName = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee33(_ref36, searchCtoName) {
      var commit;
      return regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              commit = _ref36.commit;
              commit('setCtoName', searchCtoName);

            case 2:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33);
    }));

    function setCtoName(_x50, _x51) {
      return _setCtoName.apply(this, arguments);
    }

    return setCtoName;
  }(),
  setCompanyName: function () {
    var _setCompanyName = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee34(_ref37, searchCompanyName) {
      var commit;
      return regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              commit = _ref37.commit;
              commit('setCompanyName', searchCompanyName);

            case 2:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34);
    }));

    function setCompanyName(_x52, _x53) {
      return _setCompanyName.apply(this, arguments);
    }

    return setCompanyName;
  }(),
  setIndustryName: function () {
    var _setIndustryName = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee35(_ref38, searchIndustryName) {
      var commit;
      return regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              commit = _ref38.commit;
              commit('setIndustryName', searchIndustryName);

            case 2:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35);
    }));

    function setIndustryName(_x54, _x55) {
      return _setIndustryName.apply(this, arguments);
    }

    return setIndustryName;
  }(),
  setTel: function () {
    var _setTel = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee36(_ref39, searchTel) {
      var commit;
      return regeneratorRuntime.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              commit = _ref39.commit;
              commit('setTel', searchTel);

            case 2:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36);
    }));

    function setTel(_x56, _x57) {
      return _setTel.apply(this, arguments);
    }

    return setTel;
  }(),
  clear: function () {
    var _clear = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee37(_ref40) {
      var commit;
      return regeneratorRuntime.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              commit = _ref40.commit;
              commit('clear');

            case 2:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee37);
    }));

    function clear(_x58) {
      return _clear.apply(this, arguments);
    }

    return clear;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};